import { render, staticRenderFns } from "./Peixun.vue?vue&type=template&id=28f0559e&scoped=true"
import script from "./Peixun.vue?vue&type=script&lang=js"
export * from "./Peixun.vue?vue&type=script&lang=js"
import style0 from "./Peixun.vue?vue&type=style&index=0&id=28f0559e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28f0559e",
  null
  
)

export default component.exports